// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.MyProfileToolbar.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import MyProfileAlert from './Izenda.MyProfileAlert';
import connect from 'share/enhancers/Izenda.Connect';
import IconMenu from 'share/components/controls/Izenda.IconMenu';
import Button from 'share/components/controls/Izenda.Button';
import { propTypes as ObservablePropTypes } from 'mobx-react';
import actions from './Izenda.MyProfileToolbarActions';

@connect(actions)
export default class MyProfileToolbar extends Component {
  static propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  componentWillUnmount() {
    this.props.store.model.reset();
  }

  render() {
    const { localization, store: {model: { alertMessage } } } = this.props;

    return (
      <div className='izenda-Wrapper-header'>
        <div className='u_inlineBlock u_fullWidth'>
          <IconMenu />
          <MyProfileAlert alertMessage={alertMessage} />
          <div className='izenda-ActionBarLeft u_paddingTop'>
            <strong className='u_textUppercase'>
              {localization.getText('USER_MENU_MY_PROFILE')}
            </strong>
          </div>
          <div className='izenda-ActionBarRight'>
            <Button label={localization.getText('COMMON_LABEL_SAVE')} onClick={this.props.onSave} />
            <Button label={localization.getText('COMMON_LABEL_CANCEL')} onClick={this.props.onCancel} className='btn-report-default' />
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/modules/MyProfile/Toolbar/Izenda.MyProfileToolbar.js